// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_9d7945e","betDetails":"_150a6d5"};